module.exports = __webpack_public_path__ + "fonts/montserrat-medium-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Montserrat/montserrat-medium-webfont.woff2
// module id = 3437
// module chunks = 0